import { useState } from "react";

export const PayrollOverview = ({ showTab, hideAmount }) => {
  const ytdItems = [
    { label: 'Gross Earned', val: '₹13,22,640', pct: 92, color: 'var(--brand)' },
    { label: 'TDS Deducted', val: '₹76,615', pct: 68, color: 'var(--danger)' },
    { label: 'PF Deducted (EE)', val: '₹19,800', pct: 45, color: '#8b5cf6' },
    { label: 'Net Credited', val: '₹11,13,245', pct: 82, color: 'var(--success)' },
  ];

  const leaveData = [
    { name: 'Casual Leave', code: 'CL', total: 8, avail: 3, color: '#3b82f6' },
    { name: 'Sick Leave', code: 'SL', total: 6, avail: 2, color: '#f59e0b' },
    { name: 'Earned Leave', code: 'EL', total: 15, avail: 8, color: '#10b981' },
    { name: 'Comp Off', code: 'CO', total: 2, avail: 1, color: '#8b5cf6' },
  ];

  const renderAmt = (value) => {
    return hideAmount ? "•••••" : `₹${value.toLocaleString("en-IN")}`;
  };

  const renderHeroNet = (value) => {
    return hideAmount ? "•••••" : `₹${value}`;
  };

  return (
    <div className="tab-panel pl-0 pr-0 active" id="tab-overview">
      {/* Hero Card */}
      <div className="hero-card">
        <div className="hero-emp-avatar">RK</div>
        <div className="hero-emp-info">
          <div className="hero-name">Ravindra Kumar</div>
          <div className="hero-sub">
            Sr. Engineer &nbsp;·&nbsp; Engineering &nbsp;·&nbsp; OG0054 &nbsp;·&nbsp; Joined 30 Oct 2018
          </div>
          <div className="hero-stats">
            <div>
              <div className="hero-stat-val">{renderHeroNet('14.1L')}</div>
              <div className="hero-stat-label">Annual CTC</div>
            </div>
            <div className="hero-stat-divider" />
            <div>
              <div className="hero-stat-val">New</div>
              <div className="hero-stat-label">Tax Regime</div>
            </div>
            <div className="hero-stat-divider" />
            <div>
              <div className="hero-stat-val hero-stat-val--sm">DYQPR3447M</div>
              <div className="hero-stat-label">PAN</div>
            </div>
            <div className="hero-stat-divider" />
            <div>
              <div className="hero-stat-val hero-stat-val--sm">101201354013</div>
              <div className="hero-stat-label">UAN</div>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-net-label">Net Pay — March 2025</div>
          <div className="hero-net-val" id="heroNetVal">
            {renderHeroNet('1,01,312')}
          </div>
          <div className="hero-net-sub">Credited to •••• 1163</div>
          <div className="hero-status">
            <i className="fa-solid fa-circle-check hero-status-icon" /> Disbursed 31 Mar 2025
          </div>
        </div>
      </div>

      {/* YTD + Attendance + Leave */}
      <div className="g3">
        {/* YTD */}
        <div className="sec-card sec-card--no-mb">
          <div className="sec-card-head">
            <i className="fa-solid fa-chart-line text-brand" />
            <h6>YTD Summary — FY 2024–25</h6>
          </div>
          <div className="sec-card-body">
            {ytdItems.map((item, i) => (
              <div key={i} className="ytd-row">
                <div className="ytd-row-header">
                  <span className="ytd-row-label">{item.label}</span>
                  <strong className="ytd-row-val" style={{ color: item.color }}>{item.val}</strong>
                </div>
                <div className="ytd-bar">
                  <div className="ytd-fill" style={{ width: `${item.pct}%`, background: item.color }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Attendance */}
        <div className="sec-card sec-card--no-mb">
          <div className="sec-card-head">
            <i className="fa-solid fa-calendar-check text-brand" />
            <h6>Attendance — March 2025</h6>
          </div>
          <div className="sec-card-body">
            <div className="att-ring-wrap">
              <div className="att-ring">
                <svg width="100" height="100" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="40" fill="none" stroke="#e9ecef" strokeWidth="10" />
                  <circle
                    cx="50"
                    cy="50"
                    r="40"
                    fill="none"
                    stroke="#10b981"
                    strokeWidth="10"
                    strokeDasharray="251.2"
                    strokeDashoffset="18.1"
                    strokeLinecap="round"
                  />
                </svg>
                <div className="att-ring-label">
                  <div className="att-ring-num">28</div>
                  <div className="att-ring-sub">/ 31 days</div>
                </div>
              </div>
              <div className="att-stats">
                <div className="att-stat">
                  <div className="att-dot att-dot--success" />
                  <span>Present: <strong>28 days</strong></span>
                </div>
                <div className="att-stat">
                  <div className="att-dot att-dot--danger" />
                  <span>LOP: <strong className="text-danger">0 days</strong></span>
                </div>
                <div className="att-stat">
                  <div className="att-dot att-dot--info" />
                  <span>On Leave: <strong>3 days</strong></span>
                </div>
                <div className="att-stat">
                  <div className="att-dot att-dot--holiday" />
                  <span>Holidays: <strong>3 days</strong></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Leave Balance */}
        <div className="sec-card sec-card--no-mb">
          <div className="sec-card-head">
            <i className="fa-solid fa-umbrella-beach text-brand" />
            <h6>Leave Balance</h6>
            <span className="sec-card-head-meta">FY 2024–25</span>
          </div>
          <div className="sec-card-body">
            {leaveData.map((l, i) => {
              const pct = Math.round((l.avail / l.total) * 100);
              return (
                <div key={i} className="leave-row">
                  <div className="leave-row-header">
                    <span>
                      <span className="leave-code" style={{ color: l.color }}>{l.code}</span>
                      {l.name}
                    </span>
                    <span className="leave-count">
                      {l.avail} <span className="leave-total">/ {l.total}</span>
                    </span>
                  </div>
                  <div className="ytd-bar ytd-bar--sm">
                    <div className="ytd-fill" style={{ width: `${pct}%`, background: l.color }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Quick Links */}
      <div className="g2 g2--no-mb">
        {/* Latest Payslip */}
        <div className="sec-card sec-card--no-mb">
          <div className="sec-card-head">
            <i className="fa-regular fa-file-lines text-brand" />
            <h6>Latest Payslip</h6>
            <span className="sec-card-head-action">
              <button className="btn btn-light btn-sm no-print" onClick={() => showTab('payslips')}>
                <i className="fa-solid fa-list" /> All Payslips
              </button>
            </span>
          </div>
          <div className="sec-card-body">
            <div className="no-slip">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="M14 2.22179C13.3538 2.09076 12.6849 2.02197 12 2.02197C6.47715 2.02197 2 6.49421 2 12.011C2 17.5277 6.47715 22 12 22C17.5228 22 22 17.5277 22 12.011C22 11.3269 21.9311 10.6587 21.8 10.0132" />
                <path d="M12 9.01428C10.8954 9.01428 10 9.68512 10 10.5126C10 11.3401 10.8954 12.011 12 12.011C13.1046 12.011 14 12.6819 14 13.5093C14 14.3368 13.1046 15.0077 12 15.0077M12 9.01428C12.8708 9.01428 13.6116 9.43123 13.8862 10.0132M12 9.01428V8.01538M12 15.0077C11.1292 15.0077 10.3884 14.5908 10.1138 14.0088M12 15.0077V16.0066" />
                <path d="M21.9951 2L17.8193 6.17362M16.9951 2.52119L17.1133 5.60928C17.1133 6.33713 17.5484 6.79062 18.3409 6.84782L21.465 6.99451" />
              </svg>
              <h4>No Pay Slip</h4>
              <p>You currently have no payslips available.</p>
            </div>
            <div className="slip">
              <div className="slip-month">
                <div className="slip-month-name">Mar</div>
                <div className="slip-month-year">2025</div>
              </div>
              <div className="slip-details">
                <div className="slip-meta">
                  March 2025 &nbsp;&bull;&nbsp; 31 days &nbsp;&bull;&nbsp; AWD 28
                </div>
                <div className="slip-amounts">
                  <div>
                    <span className="slip-amt-label">Gross:</span>{' '}
                    <span className="amt" data-v="118977">{renderAmt(118977)}</span>
                  </div>
                  <div>
                    <span className="slip-amt-label">Deductions:</span>{' '}
                    <span className="amt amt--danger" data-v="17665">{renderAmt(17665)}</span>
                  </div>
                  <div>
                    <span className="slip-amt-label">Net:</span>{' '}
                    <span className="amt amt--brand" data-v="101312">{renderAmt(101312)}</span>
                  </div>
                </div>
                <div className="slip-actions no-print">
                  <button className="btn btn-brand btn-sm" onClick={() => showTab('payslips')}>
                    <i className="fa-solid fa-eye" /> View Slip
                  </button>
                  <button className="btn btn-light btn-sm">
                    <i className="fa-solid fa-file-pdf" /> Download PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Active Loan */}
        <div className="sec-card sec-card--no-mb">
          <div className="sec-card-head">
            <i className="fa-solid fa-hand-holding-dollar text-brand" />
            <h6>Active Loan</h6>
            <span className="sec-card-head-action">
              <button className="btn btn-light btn-sm no-print" onClick={() => showTab('loans')}>
                <i className="fa-solid fa-list" /> All Loans
              </button>
            </span>
          </div>
          <div className="sec-card-body">
            <div className="no-loan">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <path d="M14 2.22179C13.3538 2.09076 12.6849 2.02197 12 2.02197C6.47715 2.02197 2 6.49421 2 12.011C2 17.5277 6.47715 22 12 22C17.5228 22 22 17.5277 22 12.011C22 11.3269 21.9311 10.6587 21.8 10.0132" />
                <path d="M12 9.01428C10.8954 9.01428 10 9.68512 10 10.5126C10 11.3401 10.8954 12.011 12 12.011C13.1046 12.011 14 12.6819 14 13.5093C14 14.3368 13.1046 15.0077 12 15.0077M12 9.01428C12.8708 9.01428 13.6116 9.43123 13.8862 10.0132M12 9.01428V8.01538M12 15.0077C11.1292 15.0077 10.3884 14.5908 10.1138 14.0088M12 15.0077V16.0066" />
                <path d="M21.9951 2L17.8193 6.17362M16.9951 2.52119L17.1133 5.60928C17.1133 6.33713 17.5484 6.79062 18.3409 6.84782L21.465 6.99451" />
              </svg>
              <h4>No active loans</h4>
              <p>You currently have no ongoing loans. Apply for one anytime.</p>
            </div>
            <div className="loan">
              <div className="loan-header">
                <div>
                  <div className="loan-title">Personal Loan</div>
                  <div className="loan-subtitle">
                    Disbursed Apr 2024 &nbsp;&bull;&nbsp; 24 months tenure
                  </div>
                </div>
                <span className="badge badge-active">Active</span>
              </div>

              <div className="loan-stats">
                <div>
                  <div className="ls-label">Loan Amt</div>
                  <div className="ls-val">{renderAmt(120000)}</div>
                </div>
                <div>
                  <div className="ls-label">Repaid</div>
                  <div className="ls-val ls-val--success">{renderAmt(55000)}</div>
                </div>
                <div>
                  <div className="ls-label">Outstanding</div>
                  <div className="ls-val ls-val--warning">{renderAmt(65000)}</div>
                </div>
                <div>
                  <div className="ls-label">Next EMI</div>
                  <div className="ls-val">{renderAmt(5000)}</div>
                </div>
              </div>

              <div className="loan-progress-row">
                <div className="pbar-wrap">
                  <div className="pbar-fill" style={{ width: '46%' }} />
                </div>
                <span className="loan-progress-label">46% &bull; 13 EMIs left</span>
              </div>

              <button className="btn btn-light btn-sm no-print" onClick={() => showTab('loans')}>
                <i className="fa-solid fa-file-lines" /> View Repayment Schedule
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollOverview;
